export const DDC_MAPS = 'ddc.maps';

function maps() {
	// empty eventData below {} left in place as to not break any funky code relying on eventData to be defined for this event
	return {
		eventType: DDC_MAPS,
		eventData: {}
	};
}

export default maps;
